var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "audience"
    }
  }, [_c('header', [_c('i', {
    staticClass: "iconfont icon-participants"
  }), _c('span', {
    staticClass: "title"
  }, [_vm._v("Audience")]), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-help pointer"
  }), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(_vm._s(_vm.tipsText.part1) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.tipsText.part2) + " "), _c('br'), _vm._v(" " + _vm._s(_vm.tipsText.part3))])]), _c('span', {
    staticClass: "waitingNumber"
  }, [_vm._v("(" + _vm._s(_vm.waitingNumber) + ")")])], 1), _c('main', {
    staticClass: "content"
  }, _vm._l(10, function (i) {
    return _c('div', {
      key: i,
      staticClass: "contentList"
    }, [_c('div', {
      staticClass: "list-left ellipsis"
    }, [_vm._v(_vm._s(i))]), _c('div', {
      staticClass: "list-right"
    }, [_c('operate-button', {
      attrs: {
        "btnList": _vm.operateList,
        "userInfo": _vm.userInfo,
        "singChannel": {},
        "nickName": "Thomas",
        "organization": "host"
      },
      on: {
        "callback": _vm.operateCallback
      }
    })], 1)]);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };